import React from 'react';

const FloatingShapes = () => {
  return (
    <div className="shapes">
      <div className="shape shape-1"></div>
      <div className="shape shape-2"></div>
      <div className="shape shape-3"></div>
      <div className="shape shape-4"></div>
    </div>
  );
};

export default FloatingShapes; 